import {TimerIcon} from "../../../assets/icons/TimerIcon";
import ClickIcon from "../../../assets/icons/ClickIcon";
import {formatDateForAmPmDisplay} from "../../../utils/friendlyDate";
import {Campaign} from "../../../types/CampaignProps";
import "./campaign-trigger-label.css";

interface CampaignTriggerLabelProps {
    isManual: boolean;
    campaign?: Campaign;
}

const CampaignTriggerLabel = ({ isManual, campaign }: CampaignTriggerLabelProps) => {
    return (
        <div className="campaign-thumb-sub-title">
            <div className="trigger-icon">{!isManual && campaign?.triggerTime ? <TimerIcon width={18} color='#d3d3d3' /> : <ClickIcon width={18} color='#d3d3d3' />}</div>
            <span>{!isManual && campaign?.triggerTime ? `Scheduled for ${formatDateForAmPmDisplay(new Date(campaign.triggerTime))}` : 'Manually Launched'}</span>
        </div>
    );
}

export default CampaignTriggerLabel;